import { useState, useEffect } from 'react';
import { Box, Image } from '@chakra-ui/react';
import icon1 from '../../../assets/home/hero/seo.png';
import icon2 from '../../../assets/home/hero/social.png';
import icon3 from '../../../assets/home/hero/email.png';
import icon4 from '../../../assets/home/hero/appandweb.png';
import icon5 from '../../../assets/home/hero/brand.png';
import icon6 from '../../../assets/home/hero/content.png';
import doggleicon from '../../../assets/home/hero/doggleicon.png';
import { useNavigate } from 'react-router-dom';


const icons = [icon1, icon2, icon3, icon4, icon5, icon6];

const labels = [null, null, null, "Application", 'Branding', "Marketing"];


const positionStyles = [
  { top: ["66px", "80px"], left: ["49%", "50%"], transform: "translateX(-50%)" }, // 0: Top
  { top: ["54%", "52%"], right: ["50px", "46px"], transform: "translateY(-50%)" }, // 1: Right
  { bottom: ["27%", "24%"], right: ["52px", "48px"], transform: "translateY(50%)" }, // 2: Bottom-right
  { bottom: ["19px", "-5px"], left: ["49%", "50%"], transform: "translateX(-50%)" }, // 3: Bottom
  { bottom: ["28%", "24%"], left: ["50px", "48px"], transform: "translateY(50%)" }, // 4: Bottom-left
  { top: ["53%", "54%"], left: ["48px", "49px"], transform: "translateY(-50%)" }, // 5: Left
];

const DoggleFlower = () => {
  const [currentPositions, setCurrentPositions] = useState([...positionStyles]);
  const [currentIcons, setCurrentIcons] = useState([...icons]);
  const [currentLabels, setCurrentLabels] = useState([...labels]);
  

  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      
      setCurrentPositions(prev => {
        const newPositions = [...prev];
        const firstPosition = newPositions.shift(); 
        return [...newPositions, firstPosition]; 
      });
    
      setCurrentIcons(prev => {
        const [first, ...rest] = prev;
        return [ first ,...rest];
      });
      
      setCurrentLabels(prev => {
        const [first, ...rest] = prev;
        return [first, ...rest];
      });


    }, 2000);

    return () => clearInterval(interval);
  }, []);


  const handleIconClick = (label) => {
    if (label) {
      setTimeout(() => {
        navigate('/our-work', { state: { selectedTabLabel: label } });
      }, 50)
    }  else {
      navigate('/');
    }
  };


  return (
    <Box position="relative" width={['200px', '300px']} height={['200px', '300px']} mx="auto">
      
      <Box
        position="absolute"
        top={{ base: "62%", md: "65%" }}
        left="50%"
        transform="translate(-50%, -50%)"
        width={['50px', '100px']}
        height={['50px', '100px']}
        borderRadius="full"
        // bg="white"
        // border={["3px solid #0F94B4", "4px solid #0F94B4"]}
        display="flex"
        alignItems="center"
        justifyContent="center"
        zIndex="2"
      >
        {/* <Text fontWeight="bold" fontSize={['7px', 'lg']}>doggle*</Text> */}
        <Image src={doggleicon} alt='doggleicon'/>
      </Box>

      {currentPositions.map((position, i) => (
        <Box
          key={i}
          position="absolute"
          width={['40px', '80px']}
          height={['45px', '85px']}
          borderRadius="full"
          // bg="white"
          // border={["3px solid #0F94B4", "5px solid #0F94B4"]}
          display="flex"
          alignItems="center"
          justifyContent="center"
          transition="all .1s ease"
          opacity={position === positionStyles[0] ? 1 : 0.6} 
          zIndex={position === positionStyles[0] ? 1 : 0}
          {...position}
          onClick={() => handleIconClick(currentLabels[i])}
          cursor="pointer"
        >
          <Image 
            src={currentIcons[i]} 
            alt={`icon-${i}`} 
            boxSize={['55px', '85px']} 
          />
        </Box>
      ))}
    </Box>
  );
};

export default DoggleFlower;